import BigNumber from 'bignumber.js';
import { toChecksumAddressWrapper } from './checksumAddress';

const calculateUSDValue = (
  tokenAddress: string,
  tokenAmount: BigNumber,
  ratesAddress: any
): string => {
  try {
    const addr = toChecksumAddressWrapper(tokenAddress);
    if (tokenAmount.eq(0) || tokenAmount.isNaN() || !ratesAddress[addr]) {
      return '0.0';
    }

    return new BigNumber(ratesAddress[addr]).times(tokenAmount).toFixed(2);
  } catch (e) {
    console.error(e);

    return '0.0';
  }
};

export { calculateUSDValue };
